import { IThamSoHeThongUpdateActiveStatus } from "../../../model/request/category/IThamSoHeThongUpdateActiveStatus";
import { IThamSoHeThongUpdateRequest } from "../../../model/request/category/IThamSoHeThongUpdateRequest";
import { IThamSoHeThongChucNangViewModel } from "../../../model/response/category/IThamSoHeThongChucNangViewModel";
import { IThamSoHeThongViewModel } from "../../../model/response/category/IThamSoHeThongViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThamSoHeThongChucNangActionsObj = {
    SELECT_BY_CHUC_NANG: "",
    SELECT_BY_CHUC_NANG_SUCCESS: {} as IThamSoHeThongChucNangViewModel[],
    SELECT_BY_CHUC_NANG_ERROR: "",

    UPDATE_ACTIVE_STATUS_START: {} as IThamSoHeThongUpdateActiveStatus,
    UPDATE_ACTIVE_STATUS_SUCCESS: {} as IThamSoHeThongUpdateActiveStatus,
    UPDATE_ACTIVE_STATUS_ERROR: "",


    UPDATE_THAM_SO_START: {} as IThamSoHeThongUpdateRequest,
    UPDATE_THAM_SO_SUCCESS: {} as IThamSoHeThongViewModel,
    UPDATE_THAM_SO_ERROR: "",

    DELETE_THAM_SO_START: 0,
    DELETE_THAM_SO_SUCCESS: undefined,
    DELETE_THAM_SO_ERROR: "",

}

export const eThamSoHeThongChucNangActionIds = generateActionTypeIds(eThamSoHeThongChucNangActionsObj, "THAM_SO_HE_THONG_CHUC_NANG");
export type IThamSoHeThongChucNangActionTypes = IGenericActionType<typeof eThamSoHeThongChucNangActionsObj,"THAM_SO_HE_THONG_CHUC_NANG">;